import { render, staticRenderFns } from "./StaticIBE.vue?vue&type=template&id=5aa67ea8&lang=pug&"
import script from "./StaticIBE.vue?vue&type=script&lang=js&"
export * from "./StaticIBE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports